import { IProperty } from 'features/calls/types'
import { formatValue } from 'features/calls/utils/callUtils'
import { useEffect, useState } from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'
import styled from 'styled-components'

// types and utils
interface IProps {
  rows: IProperty[]
  title: string
  callState: string
}

const CallInfoGroupDetails = ({ title, rows /* callState */ }: IProps) => {
  const callTakenOver = false
  const conversationStatus = ''
  // props and utils
  // Some groups should start closed
  /**
   * Removing this as Justin asked to expand data for live call
   */
  // const initialOpenState = [ClaimDetailsGroupsEnum.claim as string].includes(title)

  // local state
  const [open, setOpen] = useState(true)
  const [interventionMode, setInterventionMode] = useState(false)

  // effects
  useEffect(() => {
    if (callTakenOver && !interventionMode) setInterventionMode(true)

    if (!callTakenOver && interventionMode) setInterventionMode(false)
  }, [callTakenOver, interventionMode])

  useEffect(() => {
    if (['editing'].includes(conversationStatus) && !interventionMode) setInterventionMode(true)

    if (!callTakenOver && !['editing'].includes(conversationStatus) && interventionMode) setInterventionMode(false)
  }, [conversationStatus, interventionMode, callTakenOver])

  // handlers
  const toggleOpen = () => setOpen((prevOpen) => !prevOpen)

  const handleClick = (/* message: string | number | undefined */) => {
    if (interventionMode) {
      // dispatch(updateConversationStatus({ replyMessage: message }))
    }
  }

  return (
    <Details className="claim-info-container" open={true}>
      <summary onClick={toggleOpen}>
        <h3>
          {title} {open ? <FaAngleDown size={15} /> : <FaAngleUp size={15} />}
        </h3>
      </summary>
      <ul className="intervention-mode">
        {rows?.map((row, i) => {
          const value = formatValue(row)
          return (
            <li key={`title${i}`}>
              <div onClick={() => row.value !== 'Unavailable' && handleClick(/* value */)}>
                <p className="text-capitalize">{row.friendlyName}</p>
                <span className="dashed"></span>
                <span className="propriety-value">{value}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </Details>
  )
}

const Details = styled.details`
  font-size: 1rem;
  line-height: 100%;
  color: ${({ theme }) => theme.colors.primary.dark};
  margin: 0.375rem 1.5rem;
  summary {
    cursor: pointer;
    list-style: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter};
    height: ${({ theme }) => theme.util.pixelToRem(48)};
    display: flex;
    align-items: center;
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary.lightest};
    background: ${({ theme }) => theme.colors.grey.lightest};

    h3 {
      font-size: 1rem;
      line-height: 150%;
      padding: ${({ theme }) => `${theme.util.pixelToRem(13)} ${theme.util.pixelToRem(28)}`};
      color: ${({ theme }) => theme.colors.primary.darker};
      text-transform: capitalize;
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      width: 100%;
      font-style: normal;
      display: flex;
      align-items: center;
      justify-content: space-between;

      svg {
        color: ${({ theme }) => theme.colors.primary.neutral};
      }
    }
  }

  summary::marker {
    display: none;
  }

  ul {
    padding: ${({ theme }) => `${theme.util.pixelToRem(10)} 1.75rem ${theme.util.pixelToRem(10)}`};
    font-weight: ${({ theme }) => theme.fontWeight.normal};
    font-size: 1rem;
    background: ${({ theme }) => theme.colors.neutral.lightest};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);

    li > div:first-child {
      span:not(.dashed),
      p {
        max-width: 50%;
        color: ${({ theme }) => theme.colors.grey.darker};
      }

      span {
        text-align: right;
        word-break: break-word;
      }
    }

    li {
      color: ${({ theme }) => theme.colors.grey.neutral};
      padding-top: ${({ theme }) => theme.util.pixelToRem(12)};
      padding-bottom: ${({ theme }) => theme.util.pixelToRem(12)};

      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span.dashed {
          border-bottom: 1px dashed ${({ theme }) => theme.colors.grey.light};
          position: relative;
          top: 0.25rem;
          flex: 1;
        }

        &.previous-value {
          margin-top: 0.3rem;
          color: ${({ theme }) => theme.colors.primary.dark};

          img {
            position: relative;
            bottom: ${({ theme }) => theme.util.pixelToRem(5)};
            left: ${({ theme }) => theme.util.pixelToRem(3)};
            margin-right: ${({ theme }) => theme.util.pixelToRem(6)};
          }
        }
        span {
          &.propriety-value {
            font-weight: ${({ theme }) => theme.fontWeight.normal};
          }

          &.unavailable {
            cursor: default;
            color: ${({ theme }) => theme.colors.grey.neutral};
            opacity: 0.45;
          }
        }

        p {
          margin-bottom: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          ${({ theme }) => theme.typography.m.normal};
        }
      }
    }
  }

  .buttonContainer {
    margin-top: 1rem;
    text-align: center;
    padding: 0.85rem 1.75rem 1rem;
  }
`

export { CallInfoGroupDetails }
